import axios from "axios";
import { PythonTopResumeAndMatch } from "../../api-routes";
import { axiosInstancePython, axiosInstance } from "../../utils/axiosInstance";
import { useMutation } from "@tanstack/react-query";

const uploadJobDescriptionsAndResumes = async (formData) => {
  return (
    await axiosInstancePython.post(
      PythonTopResumeAndMatch.UPLOAD_JD_AND_RESUMES,
      formData
    )
  ).data;
};
const matchingProcessAllResumes = async () => {
  return (
    await axiosInstancePython.post(
      "run-matching-process-all-resumes",
      {},
      { timeout: 300000 }
    )
  ).data;
};
const bulkResumeUpload = async (data) => {
  return (
    await axiosInstance.post("api/element/resume/bulk-resume-upload", data)
  ).data;
};
const matchingProcessTopResumes = async () => {
  return (
    await axiosInstancePython.post(PythonTopResumeAndMatch.MATCH_TOP_RESUMES)
  ).data;
};

const createNewJobDescription = async (data) => {
  return (
    await axiosInstancePython.post(PythonTopResumeAndMatch.CREATE_NEW_JD, data)
  ).data;
};

const getDetaileResume = async (params) => {
  const { jdResumeSessionId, candidateId } = params;
  return (
    await axiosInstancePython.get(
      PythonTopResumeAndMatch.GET_DETAILDED_RESUME +
        `/${jdResumeSessionId}/${candidateId}`
    )
  ).data;
};
const downloadTopResume = async (id) => {
  try {
    const response = await axiosInstancePython.get(
      PythonTopResumeAndMatch.DOWNLOAD_MATCHING_RESULTS + `/${id}`,
      { responseType: "blob" }
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;

    const contentDisposition = response.headers["content-disposition"];
    const fileName = contentDisposition
      ? contentDisposition.split("filename=")[1].replace(/"/g, "")
      : "matching_results.xlsx";

    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();

    return response;
  } catch (error) {
    console.error("Error downloading the file:", error);
    throw error;
  }
};

export const useUploadJobDescriptionsAndResumes = () => {
  return useMutation({
    mutationFn: uploadJobDescriptionsAndResumes,
  });
};

export const useMatchingProcessallResumes = () => {
  return useMutation({
    mutationFn: () => matchingProcessAllResumes(),
  });
};

export const useMatchingProcessTopResumes = () => {
  return useMutation({
    mutationFn: () => matchingProcessTopResumes(),
  });
};

export const useCreateNewJobDescription = () => {
  return useMutation({
    mutationFn: (data) => createNewJobDescription(data),
  });
};

export const useGetDetaileResume = () => {
  return useMutation({
    mutationFn: (params) => getDetaileResume(params),
  });
};

export const useDownloadResumeList = () => {
  return useMutation({
    mutationFn: (id) => downloadTopResume(id),
  });
};

export const useBulkResumeUpload = () => {
  return useMutation({
    mutationFn: (data) => bulkResumeUpload(data),
  });
};
